import { render } from "./EstadisticaMetas.vue?vue&type=template&id=49c30efa"
import script from "./EstadisticaMetas.vue?vue&type=script&lang=js"
export * from "./EstadisticaMetas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__